"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var SupportPlayerPersonalPromoCodeRequest = /** @class */ (function (_super) {
    __extends(SupportPlayerPersonalPromoCodeRequest, _super);
    function SupportPlayerPersonalPromoCodeRequest(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    SupportPlayerPersonalPromoCodeRequest.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AP = this.props.availPromoOffers.Subscribe("*", function (id, data) {
            _this.setState({ avail_promo_offers: data.data }, function () {
                if (_this.state.avail_promo_offers.length > 0) {
                    _this.setState({
                        promo_offer_id: _this.state.avail_promo_offers[0].key,
                        promo_offer_title: _this.state.avail_promo_offers[0].value,
                    });
                }
            });
        });
        this.setState({
            description: "",
            player_login_or_email: "",
            promo_offer_id: 0,
            promo_offer_title: "",
            avail_promo_offers: [],
            brand_id: this.props.avail_brands[0].key,
            brand_title: this.props.avail_brands[0].value,
        }, function () {
            _this.props.state.setExtBreadCrumbPath(["Запрос персонального бонуса"]);
            _this.props.availPromoOffers.LoadData(_this.state.brand_id);
        });
        this.doReSetRules();
    };
    SupportPlayerPersonalPromoCodeRequest.prototype.componentWillUnmount = function () {
        this.props.availPromoOffers.UnSubscribe(this.SID_AP);
    };
    SupportPlayerPersonalPromoCodeRequest.prototype.doReSetRules = function () {
        this.setState({
            promo_offer_rules: { isError: false },
            player_login_or_email_rules: { isError: false },
            brand_rules: { isError: false },
        });
    };
    SupportPlayerPersonalPromoCodeRequest.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.promo_offer_id <= 0) || (this.state.promo_offer_title.length === 0)) {
            this.setState({ promo_offer_rules: { isError: true, errorMessage: "Поле [Персональный оффер] не выбрано!" } });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [Бренд] не выбрано!" } });
            return false;
        }
        if (this.state.player_login_or_email.length <= 0) {
            this.setState({ player_login_or_email_rules: { isError: true, errorMessage: "Поле [логин или почта] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        return true;
    };
    SupportPlayerPersonalPromoCodeRequest.prototype.OnNewDataClick = function () {
        var _this = this;
        if (this.isDataValid()) {
            this.props.data.doRequestPersonalPromoCode(this.state.promo_offer_id, this.state.player_login_or_email, function (success, msgText) {
                _this.setState({ description: msgText }, function () {
                    if (success) {
                        notificationHelper_1.default.ShowTextTopRightInfoNotify("Персональный промокод предоставлен!");
                    }
                    else {
                        notificationHelper_1.default.ShowTextTopRightErrorNotify("В промокоде отказано!");
                    }
                });
            });
        }
    };
    SupportPlayerPersonalPromoCodeRequest.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    SupportPlayerPersonalPromoCodeRequest.prototype.getFormTitle = function () {
        return "Добавить персональный бонус";
    };
    SupportPlayerPersonalPromoCodeRequest.prototype.onCopyTextClick = function () {
        var el = document.createElement('textarea');
        el.value = "" + this.state.description;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041E\u0442\u0432\u0435\u0442 \u0438\u0433\u0440\u043E\u043A\u0443 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0431\u0443\u0444\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430"));
    };
    SupportPlayerPersonalPromoCodeRequest.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Логин или почта", placeholder: "Введите логин игрока или почту" }, value: this.state.player_login_or_email, onValueChanged: function (newVal) {
                    _this.setState({
                        player_login_or_email: newVal,
                        player_login_or_email_rules: { isError: false }
                    });
                }, required: true, rules: this.state.player_login_or_email_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false },
                        promo_offer_id: 0,
                        promo_offer_title: "",
                        promo_offer_rules: { isError: false }
                    }, function () {
                        _this.props.availPromoOffers.LoadData(_this.state.brand_id);
                    });
                }, items: this.props.avail_brands, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Персональный оффер:", placeholder: "Выберите персональный оффер" }, value: { key: this.state.promo_offer_id, value: this.state.promo_offer_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        promo_offer_id: newVal.key,
                        promo_offer_title: newVal.value,
                        promo_offer_rules: { isError: false }
                    });
                }, items: this.state.avail_promo_offers, required: true, rules: this.state.promo_offer_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Ответ игроку:", placeholder: "Здесь будет ответ игроку", buttonHint: "Скопировать ответ в буффер обмена" }, readonly: true, onButtonClick: this.onCopyTextClick.bind(this), onValueChanged: function (newVal) {
                    //this.setState({
                    //    description: newVal,
                    //})
                }, value: this.state.description, buttonIcon: "copy" }),
            React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
                React.createElement(antd_1.Button.Group, null,
                    React.createElement(antd_1.Button, { key: 'btn-0', style: { width: "200px" }, type: "primary", onClick: this.OnNewDataClick.bind(this) },
                        React.createElement(antd_1.Icon, { type: "select" }),
                        "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434"),
                    React.createElement(antd_1.Button, { key: 'btn-1', style: { width: "200px" }, type: "danger", onClick: this.OnGoBackClick.bind(this) },
                        React.createElement(antd_1.Icon, { type: "rollback" }),
                        "\u041D\u0430\u0437\u0430\u0434")))));
    };
    return SupportPlayerPersonalPromoCodeRequest;
}(React.Component));
exports.default = SupportPlayerPersonalPromoCodeRequest;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/support_player_personal_promocodes/ui/component/SupportPlayerPersonalPromoCodeRequest.tsx
// module id = 2587
// module chunks = 0